// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-right {
  right: 0;
  left: auto !important;
}

.dropdown-menu.arrow:before {
    left: 70px !important;
    border-bottom-color: #ffffff;
}

.dropdown-menu.arrow:after {
    top: 0px;
}

@media only screen and (max-width:767px) {
  ._dropdown_mob {
      margin-left: 150px !important;
  }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJyZWFkY3J1bWIuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFFBQVE7RUFDUixxQkFBcUI7QUFDdkI7O0FBRUE7SUFDSSxxQkFBcUI7SUFDckIsNEJBQTRCO0FBQ2hDOztBQUVBO0lBQ0ksUUFBUTtBQUNaOztBQUVBO0VBQ0U7TUFDSSw2QkFBNkI7RUFDakM7QUFDRiIsImZpbGUiOiJicmVhZGNydW1iLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZHJvcGRvd24tbWVudS1yaWdodCB7XG4gIHJpZ2h0OiAwO1xuICBsZWZ0OiBhdXRvICFpbXBvcnRhbnQ7XG59XG5cbi5kcm9wZG93bi1tZW51LmFycm93OmJlZm9yZSB7XG4gICAgbGVmdDogNzBweCAhaW1wb3J0YW50O1xuICAgIGJvcmRlci1ib3R0b20tY29sb3I6ICNmZmZmZmY7XG59XG5cbi5kcm9wZG93bi1tZW51LmFycm93OmFmdGVyIHtcbiAgICB0b3A6IDBweDtcbn1cblxuQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWF4LXdpZHRoOjc2N3B4KSB7XG4gIC5fZHJvcGRvd25fbW9iIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiAxNTBweCAhaW1wb3J0YW50O1xuICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/_layout/breadcrumb/breadcrumb.component.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,qBAAqB;AACvB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,QAAQ;AACZ;;AAEA;EACE;MACI,6BAA6B;EACjC;AACF;;AAEA,g0BAAg0B","sourcesContent":[".dropdown-menu-right {\n  right: 0;\n  left: auto !important;\n}\n\n.dropdown-menu.arrow:before {\n    left: 70px !important;\n    border-bottom-color: #ffffff;\n}\n\n.dropdown-menu.arrow:after {\n    top: 0px;\n}\n\n@media only screen and (max-width:767px) {\n  ._dropdown_mob {\n      margin-left: 150px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
